import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Clock, ChevronRight, Loader2, Lock, Crown } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const HistoryPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API}/discussions/history?limit=3`).then(r => { setData(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><Loader2 className="w-8 h-8 animate-spin text-gray-400" /></div>;

  const discussions = data?.discussions || [];
  const limited = data?.limited || false;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-8 py-8" data-testid="history-page">
      <h1 className="text-2xl font-black mb-2" style={{ fontFamily: 'Chivo, sans-serif' }}>Geschiedenis</h1>
      <p className="text-xs text-[#52525B] mb-6">
        {limited ? `${data.showing} van ${data.total} discussies (free limiet)` : `${discussions.length} discussies`}
      </p>

      {discussions.length === 0 ? (
        <div className="text-center py-12 text-[#52525B]"><Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" /><p>Nog geen discussies. Start je eerste debat!</p></div>
      ) : (
        <div className="space-y-3">
          {discussions.map(d => (
            <Link key={d.discussion_id} to={`/discussion/${d.discussion_id}`}
              className="block bg-white border border-[#E5E5E5] p-4 hover:border-[#2d8cf0] hover:-translate-y-0.5 hover:shadow-md transition-all"
              data-testid={`history-item-${d.discussion_id}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium">{d.question}</p>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className={`text-[10px] font-bold px-1.5 py-0.5 ${d.status === "completed" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}`}>{d.status}</span>
                    <span className="text-[10px] text-gray-400">{d.created_at ? new Date(d.created_at).toLocaleString() : ""}</span>
                    {d.debater_count && <span className="text-[10px] text-gray-400">{d.debater_count} debaters</span>}
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </div>
            </Link>
          ))}
        </div>
      )}

      {/* Premium upsell for limited history */}
      {limited && (
        <div className="mt-6 bg-gradient-to-r from-[#0a0e1a] to-[#1a2744] text-white p-5 flex items-center justify-between" data-testid="history-limit-banner">
          <div className="flex items-center gap-3">
            <Lock className="w-5 h-5 text-[#f59e0b]" />
            <div>
              <p className="text-sm font-bold">Je hebt {data.total} discussies, maar ziet er {data.showing}</p>
              <p className="text-xs text-gray-400 mt-0.5">Upgrade naar Premium voor onbeperkte geschiedenis</p>
            </div>
          </div>
          <button onClick={() => navigate("/premium")} className="px-4 py-2 bg-[#f59e0b] text-[#0a0e1a] text-xs font-bold hover:bg-[#d97706] transition-colors flex items-center gap-1.5 flex-shrink-0">
            <Crown className="w-3 h-3" /> PREMIUM
          </button>
        </div>
      )}
    </div>
  );
};
